import {Component, AfterViewInit, OnDestroy}   from '@angular/core'
import {Router} from '@angular/router'

import {InsaService} from '../../insa-services'
import {ChartModel} from '../../insa-models'
import {appStateProvider} from '../../insa-providers'
import {GenericChartsModule} from '../../insa-custom-scripts'

@Component({
  selector:'insaweb-performance',
  template: `<div class="canvas" id="performanceCanvas">
               <div id="PerformanceDetails" class="barChart-loading" (window:resize)="onResize($event)"></div>
           </div>`
})

export class PerformanceComponent implements AfterViewInit, OnDestroy{
  
  private maxValPerformanceDetails: number;
  private minValPerformanceDetails: number;
  private portfPerfDetailsSubscription;
  private performanceSecondSerieDescription:string;

  constructor(private _insaService: InsaService, private _appStateProvider: appStateProvider, private _router:Router) {
     this.portfPerfDetailsSubscription = this._insaService.PerformanceDetailsChartEvent.subscribe(perfDetails => this.refreshPerfDetailsBarChart(perfDetails));
  }

  private refreshPerfDetailsBarChart(perfDetails: ChartModel[]) {
    if (perfDetails !== undefined && perfDetails.length > 0) {
      this.performanceSecondSerieDescription = perfDetails[0].Description2;
      let maxValPerformanceDetailsFirstSerie = Math.max.apply(Math, perfDetails.map(function (val) { return val.Value; }));
      let maxValPerformanceDetailsSecondSerie = Math.max.apply(Math, perfDetails.map(function (val) { return val.Value2; }));

      if (maxValPerformanceDetailsFirstSerie > maxValPerformanceDetailsSecondSerie) {
        this.maxValPerformanceDetails = maxValPerformanceDetailsFirstSerie;
      } else {
        this.maxValPerformanceDetails = maxValPerformanceDetailsSecondSerie;
      }

      let minValPerformanceDetailsFirstSerie = Math.min.apply(Math, perfDetails.map(function (val) { return val.Value; }));
      let minValPerformanceDetailsSecondSerie = Math.min.apply(Math, perfDetails.map(function (val) { return val.Value2; }));

      if (minValPerformanceDetailsFirstSerie > minValPerformanceDetailsSecondSerie) {
        this.minValPerformanceDetails = minValPerformanceDetailsSecondSerie;
      } else {
        this.minValPerformanceDetails = minValPerformanceDetailsFirstSerie;
      }

      let perfHeight = this.performanceChartHeight();
      GenericChartsModule.KendoInitGenericBarChart("#PerformanceDetails", perfDetails, "PERFORMANCE DETAILS", this.minValPerformanceDetails, this.maxValPerformanceDetails,
      this.secondSerieVisibility(this.performanceSecondSerieDescription), perfHeight, this.chartPropertyVisibility(),this.chartPropertyVisibility());
    } else {
      GenericChartsModule.KendoInitGenericBarChart("#PerformanceDetails", perfDetails, "PERFORMANCE DETAILS", null, null, false, undefined,false, false);
    }
  }
  
   private secondSerieVisibility(secSerieDesc){
       if(secSerieDesc!==''){
           return true;
       }else{
           return false;
       }
   }

   private chartPropertyVisibility(){
     if(this._router.url ==="/home"){
       return false;
     }else if(this._router.url ==="/performance"){
       return true;
     }
   }

  private onResize(event) {
    let performanceDetailsChart: kendo.dataviz.ui.Chart = $("#PerformanceDetails").data("kendoChart");
    performanceDetailsChart.options.chartArea = {background: "", height: this.performanceChartHeight()};
    performanceDetailsChart.redraw();
  }

  // On the overview the canvas sits in a carousel slide that is display:none
  // while the grid slide is active; reading its height then squishes the chart.
  // Use the always-visible card height there, the canvas height on /performance.
  private performanceChartHeight(): number {
    let perfCard = $("#performanceCanvas").closest(".card");
    return perfCard.length ? perfCard.height() : $("#performanceCanvas").height();
  }

  ngAfterViewInit() {
     kendo.ui.progress($(".barChart-loading"), this._appStateProvider.fetchingPerfomanceBarChart);
     this.refreshPerfDetailsBarChart(this._insaService.chartDataPerformanceDetails); 
  }

  ngOnDestroy() {
    this.portfPerfDetailsSubscription.unsubscribe();
  }

}


// WEBPACK FOOTER //
// ./app/insa-components/insa-charts/performance-chart.component.ts